import "./index.scss";

import { StripProps } from "./types";
import { getBackgroundClassNames } from "utilities/commonPropTypes/background";
import { getSpacersClassNames } from "utilities/commonPropTypes/spacers";
import { getWrapContentClassNames } from "utilities/commonPropTypes/wrapContent";
import React from "react";
import classNames from "classnames";

const Strip = ({
  image,
  backgroundColor,
  backgroundPosition,
  backgroundSize,
  children,
  customClass,
  slug = "",
  marginBottom,
  marginTop,
  paddingBottom,
  paddingTop,
  xsWrapContent,
  mdWrapContent,
  lgWrapContent,
  xlWrapContent,
  hasPaddingWrapMobile = false,
  htmlTag = "section",
  liveInspector,
}: StripProps) => {
  const stripClasses = classNames(
    "Strip",
    customClass,
    getBackgroundClassNames({
      backgroundColor,
      backgroundPosition,
      backgroundSize,
    }),
    getSpacersClassNames({
      marginBottom,
      marginTop,
      paddingBottom,
      paddingTop,
    }),
  );
  const containerClasses = classNames(
    "Strip__content",
    "wrapContent",
    getWrapContentClassNames({
      xsWrapContent,
      mdWrapContent,
      lgWrapContent,
      xlWrapContent,
    }),
    {
      "Strip__content--has-padding-mob": hasPaddingWrapMobile,
    },
  );

  // NOTE: check is valid?
  const HtmlTag = htmlTag as React.ElementType;
  return (
    <HtmlTag id={slug} className={stripClasses} {...liveInspector?.stripItem}>
      {image && (
        <div className="Strip__background image-as-background">{image}</div>
      )}
      <div className={containerClasses}>
        <div className="Strip__content__item">{children}</div>
      </div>
    </HtmlTag>
  );
};

export default Strip;
